import {
  Container,
  Content,
  ContactDetails,
  Logo,
  Info,
  SocialIcons,
  Form,
  InputRow,
  InputWrapper,
  Label,
  Input,
  TextArea,
  SubmitButton,
} from "../styles/ContactUs.style";
import ImageContact from "../assets/image-contact.png";
import { IoLogoWhatsapp } from "react-icons/io";
import { BiLogoInstagramAlt } from "react-icons/bi";
import { FaFacebookF } from "react-icons/fa";
import HeaderSection from "../components/HeaderSection/HeaderSection";

const ContactUsPage = () => {
  return (
    <Container>
      <HeaderSection title={"Contacto"} subtitle={"Contáctanos"} />
      <Content>
        <ContactDetails>
          <Logo>
            <img src={ImageContact} alt="Contact" />
          </Logo>
          <Info>
            <p>Datos de contacto</p>
            <p>11 Avenida 15-11 Zona 10, Guatemala C.A</p>
            <p>PBX: (+502) 2504 8585</p>
          </Info>
          <SocialIcons>
            <IoLogoWhatsapp />
            <BiLogoInstagramAlt />
            <FaFacebookF />
          </SocialIcons>
        </ContactDetails>
        <Form>
          <InputRow>
            <InputWrapper>
              <Label>NOMBRE</Label>
              <Input type="text" placeholder="Nombre:" />
            </InputWrapper>
            <InputWrapper>
              <Label>TELÉFONO</Label>
              <Input type="text" placeholder="Teléfono:" />
            </InputWrapper>
          </InputRow>
          <InputWrapper>
            <Label>CORREO</Label>
            <Input type="email" placeholder="Correo electrónico:" />
          </InputWrapper>
          <InputWrapper>
            <Label>MENSAJE</Label>
            <TextArea placeholder="Escribe tu mensaje:" />
          </InputWrapper>
          <SubmitButton>Enviar</SubmitButton>
        </Form>
      </Content>
    </Container>
  );
};

export default ContactUsPage;
